import React, { Component } from 'react';

class SectionCorner extends Component {
  render() {
    const { color, style, length, corner } = this.props;
    const thickness = 8;
    let barStyle = {
      position: 'absolute',
      zIndex: 8,
      width: length,
      border: 'none',
      height: length,
      display: 'block',
      marginTop: '-10px',
      left: '50%',
      // marginLeft: thickness/2*-1,
      ...(style ? style : {})};

      switch (corner) {
        default:
        case 'bl':
        barStyle = { ...barStyle, ...{
          marginLeft: ((length+thickness)*-1)+"px",
          borderRight: thickness+'px '+color+' solid',
          borderBottom: thickness+'px '+color+' solid',
          borderTop: thickness+'px transparent solid',
          borderLeft: thickness+'px transparent solid',
          borderRadius: '0 0 20px 0',
        }};
        break;
        case 'br':
        barStyle = { ...barStyle, ...{
          marginLeft: ((length+thickness)*-1)+"px",
          borderRight: thickness+'px transparent solid',
          borderBottom: thickness+'px '+color+' solid',
          borderTop: thickness+'px transparent solid',
          borderLeft: thickness+'px '+color+' solid',
          borderRadius: '0 0 0 20px',
        }};
        break;
        case 'tl':
        barStyle = { ...barStyle, ...{
          borderRight: thickness+'px transparent solid',
          borderBottom: thickness+'px transparent solid',
          borderTop: thickness+'px '+color+' solid',
          borderLeft: thickness+'px '+color+' solid',
          borderRadius: '20px 0 0 0',
        }};
        break;
        case 'tr':
        barStyle = { ...barStyle, ...{
          borderRight: thickness+'px '+color+' solid',
          borderBottom: thickness+'px transparent solid',
          borderTop: thickness+'px '+color+' solid',
          borderLeft: thickness+'px transparent solid',
          borderRadius: '0 20px 0 0',
        }};
        break;
      }
      return (

        <span className="SectionCorner" style={{...barStyle, ...style}}></span>
      );
    }
  }

  export default SectionCorner;



// WEBPACK FOOTER //
// ./src/components/Home/Section/SectionCorner.jsx